import React from 'react';
import { useTranslation } from '../../i18n';

function timeToSeconds(timeStr) {
  if (typeof timeStr !== 'string' || !timeStr.includes(':')) return 0;
  const [h, m, s] = timeStr.split(':').map(Number);
  return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
}

function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.round(seconds % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

const LapsTableCycling = ({ laps = [], fileId }) => {
  const { t } = useTranslation();

  if (!Array.isArray(laps) || laps.length === 0) return <p></p>;

  const totals = laps.reduce((acc, lap) => {
    acc.duracion                  += timeToSeconds(lap.duracion);
    acc.distancia                 += parseFloat(lap.distancia);
    acc.calorias                  += parseFloat(lap.calorias);
    acc.ascenso                   += parseFloat(lap.ascenso);
    acc.descenso                  += parseFloat(lap.descenso);
    acc.frecuenciaCardiacaPromedio += parseFloat(lap.frecuenciaCardiacaPromedio);
    acc.frecuenciaCardiacaMaxima   += parseFloat(lap.frecuenciaCardiacaMaxima);
    acc.velocidadPromedio          += parseFloat(lap.velocidadPromedio);
    acc.velocidadMaxima            += parseFloat(lap.velocidadMaxima);
    acc.cadenciaPromedio           += parseFloat(lap.cadenciaPromedio);
    acc.temperaturaPromedio        += parseFloat(lap.temperaturaPromedio);
    acc.temperaturaMaxima          += parseFloat(lap.temperaturaMaxima);
    return acc;
  }, { duracion: 0, distancia: 0, calorias: 0, ascenso: 0, descenso: 0, frecuenciaCardiacaPromedio: 0, frecuenciaCardiacaMaxima: 0, velocidadPromedio: 0, velocidadMaxima: 0, cadenciaPromedio: 0, temperaturaPromedio: 0, temperaturaMaxima: 0 });

  const totalLaps = laps.length;

  return (
    <div className="dashboard-container">
      <div className="header" style={{ textAlign: 'center', marginTop: '2rem' }}>
        <h2>{t('laps.dashboardCyclingTitle')}</h2>
      </div>

      <div style={{ overflowX: 'auto', marginTop: '2rem' }}>
        <table className="laps-table">
          <thead>
            <tr>
              <th>{t('laps.lap')}</th>
              <th>{t('laps.duration')}</th>
              <th>{t('laps.accumulatedTime')}</th>
              <th>{t('laps.distanceKm')}</th>
              <th>{t('laps.calories')}</th>
              <th>{t('laps.ascentM')}</th>
              <th>{t('laps.descentM')}</th>
              <th>{t('laps.avgHRShort')}</th>
              <th>{t('laps.maxHRShort')}</th>
              <th>{t('laps.avgSpeedKmh')}</th>
              <th>{t('laps.maxSpeedKmh')}</th>
              <th>{t('laps.avgCadence')}</th>
              <th>{t('laps.avgTempShort')}</th>
              <th>{t('laps.maxTempShort')}</th>
            </tr>
          </thead>
          <tbody>
            {laps.map((lap, index) => (
              <tr key={lap.vuelta || index}>
                <td>{lap.vuelta}</td>
                <td>{lap.duracion}</td>
                <td>{lap.tiempoAcumulado}</td>
                <td>{lap.distancia}</td>
                <td>{lap.calorias}</td>
                <td>{lap.ascenso}</td>
                <td>{lap.descenso}</td>
                <td>{lap.frecuenciaCardiacaPromedio}</td>
                <td>{lap.frecuenciaCardiacaMaxima}</td>
                <td>{lap.velocidadPromedio}</td>
                <td>{lap.velocidadMaxima}</td>
                <td>{lap.cadenciaPromedio}</td>
                <td>{lap.temperaturaPromedio}</td>
                <td>{lap.temperaturaMaxima}</td>
              </tr>
            ))}
            {totalLaps > 0 && (
              <tr className="totals-row" style={{ backgroundColor: '#e3f2fd', fontWeight: 'bold' }}>
                <td>{t('laps.total')}</td>
                <td>{formatTime(totals.duracion)}</td>
                <td>--</td>
                <td>{totals.distancia.toFixed(2)}</td>
                <td>{totals.calorias.toFixed(0)}</td>
                <td>{totals.ascenso.toFixed(0)}</td>
                <td>{totals.descenso.toFixed(0)}</td>
                <td>{(totals.frecuenciaCardiacaPromedio / totalLaps).toFixed(0)}</td>
                <td>{(totals.frecuenciaCardiacaMaxima / totalLaps).toFixed(0)}</td>
                <td>{(totals.velocidadPromedio / totalLaps).toFixed(2)}</td>
                <td>{(totals.velocidadMaxima / totalLaps).toFixed(2)}</td>
                <td>{(totals.cadenciaPromedio / totalLaps).toFixed(0)}</td>
                <td>{(totals.temperaturaPromedio / totalLaps).toFixed(0)}</td>
                <td>{(totals.temperaturaMaxima / totalLaps).toFixed(0)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LapsTableCycling;
